import * as angular from 'angular';
import {IController, IOnChanges, IOnChangesObject} from 'angular';
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class tagsChipsAutocompleteCtrl implements IController {
  tags: any;
  options: any;
  tagTypes: string[];
  maxTags?: number;
  requireMatch: any;
  ngPlaceholder: any;
  onChange: Function;

  private tagsRef: any;
  private searchText: any;
  private selectedChips: any;

  /* @ngInject */
  constructor(private $tags, private splitService: SplitService) {

  }

  $onInit() {

    const isSite = this.splitService.getIsSite();

    if (_.isUndefined(this.requireMatch)) {
      this.requireMatch = false;
    }
    if (_.isUndefined(this.options) && !!isSite) {
      this.tagsRef = this.$tags();
      this._getSiteTags();
    }

    if (this.tags && this.tags.length) {
      this.selectedChips = _.map(this.tags, (t) => {
        return {
          name: t
        };
      })
    } else {
      this.selectedChips = [];
    }
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.tags && !changes.tags.isFirstChange()) {
      if (this.tags && this.tags.length) {
        this.selectedChips = _.map(this.tags, (t) => {
          return {
            name: t
          };
        })
      } else {
        this.selectedChips = [];
      }
    }



  }

  querySearch(query) {
    if (!query) {
      return this.options || [];
    }
    return _.filter(this.options || [], (tagOption) => {
      const lowercaseQuery = _.lowerCase(query);
      const tagOptionNameQuery = _.lowerCase(tagOption.name);

      return _.includes(tagOptionNameQuery, lowercaseQuery);
    })
  }

  transformChip(chip) {
    // If it is an object, it's already a known chip
    if (angular.isObject(chip)) {
      return chip
    }
    // Otherwise, create a new one
    return {name: chip, isNew: true}
  }

  updateTags() {
    let selectedTagNames = _.map(this.selectedChips, (c) => {
      return c.name;
    })

    if (typeof this.maxTags === "number" && selectedTagNames?.length > this.maxTags) {
      selectedTagNames.splice(0, selectedTagNames?.length - this.maxTags);
    }

    this.onChange({tagNames: selectedTagNames})
  }

  onBlur() {
    if (this.searchText) {
      this.searchText = undefined;
    }
  }

  private _getSiteTags() {
    this.options = [];
    this.tagsRef.$getAll(this._getQuery())
      .then((tagIds) => {
        return this.tagsRef.$asyncValues(tagIds);
      })
      .then((siteTags) => {

        this.options = siteTags;
      });
  }

  private _getQuery() {
    return {
      type: this.tagTypes
    }
  }


}

angular
  .module('bringoz.admin.tags')
  .component('tagsChipsAutocomplete', {
    require: {
      form: '^form'
    },
    bindings: {
      tags: '<?',
      options: '<',
      tagTypes: '<?',
      maxTags: '<?',
      requireMatch: '<?',
      isRequired: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./tags-chips-autocomplete.html').default,
    controller: tagsChipsAutocompleteCtrl
  });
